module.exports = __webpack_public_path__ + "static/media/(DH)_MG_5518_-_Pro-Natura_-_Moda_Feminina.c0ad07d8.jpg";